import { render, staticRenderFns } from "./MoveTrashOrder.vue?vue&type=template&id=64b50074&"
import script from "./MoveTrashOrder.vue?vue&type=script&lang=js&"
export * from "./MoveTrashOrder.vue?vue&type=script&lang=js&"
import style0 from "./MoveTrashOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports